module.exports = __webpack_public_path__ + "static/48invgde-3723fdc2feb86f08c973b2a19b9b87a8.gif";